/**
 * Construye el payload de la conexion WhatsApp a partir de los valores del formulario.
 * Funcion PURA (sin efectos) — testeable en aislamiento.
 * PUNTO DE EXTENSION multi-provider (0352 F.2): aqui se anaden campos condicionales
 * por provider al payload (p.ej. phoneNumberId / verifyToken para WABA Meta).
 */
export function buildWhatsAppPayload(values, ctx) {
  const {
    hasDepartment,
    currentQueueId,
    hasPrompt,
    currentPrompt,
    selectedIntegration,
    selectedFlowBuilder,
    tabStates,
    transferQueueId,
    transferWhatsappId,
  } = ctx;

  const whatsappData = {
        ...values,
        queueIds: hasDepartment && currentQueueId 
          ? [currentQueueId] // ✅ Enviar como array de un solo elemento para compatibilidad con backend
          : [],
        // ✅ CORRECCIÓN: Enviar null si transfersEnabled está desactivado O si los campos están vacíos
        transferQueueId: tabStates.transfersEnabled && transferQueueId && transferQueueId !== '' ? transferQueueId : null,
        transferWhatsappId: tabStates.transfersEnabled && transferWhatsappId && transferWhatsappId !== '' ? transferWhatsappId : null,
        promptId: hasPrompt ? currentPrompt : null,
        integrationId: selectedIntegration && selectedIntegration !== null && selectedIntegration !== "" ? selectedIntegration : null,
        flowBuilderId: selectedFlowBuilder && selectedFlowBuilder !== null && selectedFlowBuilder !== "" ? selectedFlowBuilder : null,
        // ✅ CORRECCIÓN: Enviar null si transfersEnabled está desactivado, no hay transferQueueId, o timeToTransfer está vacío
        timeToTransfer: tabStates.transfersEnabled && transferQueueId && transferQueueId !== '' && values.timeToTransfer && values.timeToTransfer !== '' 
          ? (typeof values.timeToTransfer === 'string' ? (values.timeToTransfer.trim() !== '' ? values.timeToTransfer : null) : values.timeToTransfer)
          : null,
        // ✅ ELIMINADO: Campos de chatbot - Ya no se usan (pestaña CHATBOT eliminada)
        // Los departamentos ahora trabajan de forma inteligente, no necesitan chatbot inicial
        greetingMessage: '', // ✅ Siempre vacío (no se usa)
        complationMessage: '', // ✅ Siempre vacío (no se usa)
        outOfHoursMessage: '', // ✅ Siempre vacío (no se usa)
        ratingMessage: '', // ✅ Siempre vacío (no se usa)
        // ✅ CORRECCIÓN: Si la inactividad está DESACTIVADA, limpiar esos campos (0 para expiresTicket, '' para message)
        // ✅ Si está activada pero los campos están vacíos, también limpiarlos
        expiresTicket: tabStates.inactivityEnabled && values.expiresTicket && values.expiresTicket !== '' && values.expiresTicket !== 0 
          ? values.expiresTicket 
          : 0,
        expiresInactiveMessage: tabStates.inactivityEnabled && values.expiresInactiveMessage && values.expiresInactiveMessage.trim() !== '' 
          ? values.expiresInactiveMessage 
          : ''
      };
      
      
      delete whatsappData["queues"];

  return whatsappData;
}
